<template>
  <div class="col call-chat-body">
    <div class="card">
      <div class="card-body p-0">
        <div class="row chat-box">
          <div class="col pr-0 chat-right-aside">
            <div class="chat">
              <div class="chat-header clearfix">
                <img class="rounded-circle" v-if="currentchat.thumb" :src="getImageUrl(currentchat.thumb)" alt="" />
                <div class="about">
                  <div class="name">
                    {{ currentchat.name }}<span class="font-primary f-12">Typing...</span>
                  </div>
                  <div class="status digits"> {{ currentchat.lastSeenDate }}</div>
                </div>
                <ul class="list-inline float-left float-sm-right chat-menu-icons">
                  <li class="list-inline-item">
                    <a ><i class="icon-search"></i></a>
                  </li>
                  <li class="list-inline-item">
                    <a ><i class="icon-clip"></i></a>
                  </li>
                  <li class="list-inline-item">
                    <a ><i class="icon-headphone-alt"></i></a>
                  </li>
                  <li class="list-inline-item">
                    <a ><i class="icon-video-camera"></i></a>
                  </li>
                  <li class="list-inline-item toogle-bar" data-bs-toggle="collapse" data-bs-target="#collapseExample"
                    :class="[isActive ? 'active' : '', 'collapsible']" v-on:click="toggle">
                    <a ><i class="icon-menu"></i></a>
                  </li>
                </ul>
              </div>
              <div class="chat-history chat-msg-box custom-scrollbar" ref="chatInput">
                <ul>
                  <li v-for="(chat, index) in currentChat.chat.messages" :key="index"
                    v-bind:class="{ clearfix: chat.sender == 0 }">
                    <div class="message" v-bind:class="{
                      'other-message pull-right': chat.sender == 0,
                      'my-message': chat.sender != 0
                    }">
                      <img class="rounded-circle float-start chat-user-img img-30 text-end" alt=""
                        v-if="currentchat.thumb && chat.sender != 0" v-bind:src="getImageUrl(currentchat.thumb)" />
                      <img class="rounded-circle float-end chat-user-img img-30" alt="" v-if="chat.sender == 0"
                        v-bind:src="getImageUrl('user/1.jpg')" />
                      <div class="message-data text-end" v-bind:class="{ 'text-start': chat.sender == 0 }">
                        <span class="message-data-time">{{ chat.time }}</span>
                      </div>
                      {{ chat.text }}
                    </div>
                  </li>
                </ul>
              </div>
              <addChat @message="addChat" :chatElement='chatElement' />
            </div>
          </div>
          <div class="col pl-0 chat-menu custom-scrollbar" :class="[isActive ? 'block' : 'none', 'content']"
            v-show="isActive" id="collapseExample">
            <chatMenu />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import getImage from "@/mixins/getImage"
import { mapState } from 'vuex';
import addChat from "./addChat.vue"
import chatMenu from "./chatMenu.vue"
export default {
  mixins: [getImage],
  components: { addChat, chatMenu },
  data() {
    return {
      currentchat: [], chatmenutoogle: false, isActive: false,
    }
  },
  computed: {
    ...mapState({
      currentChat() {
        return (this.currentchat = this.$store.getters['chat/currentChat']);
      },
    }),
  },
  methods: {
    addChat() {
      var container = this.$el.querySelector(".chat-history")
      setTimeout(function () {
        container.scrollBy({ top: 200, behavior: 'smooth' });
      }, 310);
      setTimeout(function () {
        container.scrollBy({ top: 200, behavior: 'smooth' });
      }, 1100);
    },
    toggle() {
      this.isActive = !this.isActive
    },
  },
}
</script>